import HelpTooltip from '@/app/common/components/HelpTooltip';
import { crawlerLimit } from '@/app/Crawl/config/modalSettingsConfig';
import type { FormikHandlers } from 'formik';
import { Col, Form, Row, Tab } from 'react-bootstrap';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';

interface NumericSetting {
  name: string;
  text: string;
  min: number;
  max: number;
  measurement: string;
}

interface LimitProps {
  values: Record<string, unknown>;
  handleBlur: FormikHandlers['handleBlur'];
  handleChange: FormikHandlers['handleChange'];
}

const Limit = ({ values, handleBlur, handleChange }: LimitProps) => {
  const settings = crawlerLimit as NumericSetting[];

  return (
    <Tab.Pane className="my-3" eventKey="crawlerLimit">
      <div dir="rtl" className="text-start">
        <Row className="g-3">
          {settings.map(item => (
            <Col key={item.name} xs={12} md={6}>
              <div className="crawl-settings-box border rounded-2 p-3 h-100">
                <Form.Label htmlFor={item.name} className="mb-2">
                  <span className="d-inline-flex align-items-center">
                    {item.text}
                    <HelpTooltip
                      html={crawlTooltip.crawlSettings.crawlerLimit[item.name]}
                    />
                  </span>
                </Form.Label>
                <div className="d-flex align-items-center gap-2">
                  <Form.Control
                    size="sm"
                    type="number"
                    value={values[item.name] as number | string | undefined}
                    name={item.name}
                    id={item.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    max={item.max}
                    min={item.min}
                  />
                  <span className="fs--2 text-700 text-nowrap">
                    از {item.min} تا {item.max} {item.measurement}
                  </span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </Tab.Pane>
  );
};

export default Limit;
